import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'node-credentials',
  templateUrl: './node-credentials.component.html',
  styleUrls: ['./node-credentials.component.scss']
})
export class NodeCredentialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
